import { render, staticRenderFns } from "./SelfDetails.vue?vue&type=template&id=14263936&scoped=true&"
import script from "./SelfDetails.vue?vue&type=script&lang=js&"
export * from "./SelfDetails.vue?vue&type=script&lang=js&"
import style0 from "./SelfDetails.vue?vue&type=style&index=0&id=14263936&prod&lang=scss&scoped=true&"
import style1 from "./SelfDetails.vue?vue&type=style&index=1&id=14263936&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14263936",
  null
  
)

export default component.exports